import { render, staticRenderFns } from "./SearchWeightPriceForm.vue?vue&type=template&id=0e2dce98&"
import script from "./SearchWeightPriceForm.vue?vue&type=script&lang=js&"
export * from "./SearchWeightPriceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports